import React from 'react';
import styles from './Opportunities.scss';

const Opportunities = () => {
  return (
    <div className={styles.wrapper}>
      <img
        src="/img/opportunities_page.svg"
        alt="background"
        className={styles.img}
      />
    </div>
  );
};

export default Opportunities;



// WEBPACK FOOTER //
// ./src/components/pages/Opportunities/Opportunities.js